import { useDbFunctions, useEvents } from "@/talons";
import styled from "styled-components";
import * as R from '@/constants/systemRoutes';
import { useEffect, useMemo, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";

const View = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
`;

const links = Object.values(R).reduce((acc, route) => {
  acc[route.link] = route.id;
  return acc
}, {} as Record<string, string>)

export default function ViewComponent({ children }: { children: React.ReactNode }) {
  const params = useParams();
  const db = useDbFunctions();
  const location = useLocation();
  const { registerEvent } = useEvents(db);
  const viewRef = useRef<HTMLDivElement>(null);

  const path = useMemo(() => {
    const param = Object.entries(params)
    return param.reduce((acc, [k, v]) => `${acc?.replace(`/${v}`, `/:${k}`)}`, location.pathname);
  }, [params, location]);

  const routeID = useMemo(() => {
    return links[path];
  }, [path]);

  useEffect(() => {
    if (!viewRef.current) return;

    const el = viewRef.current;
    const observer = new IntersectionObserver(
      async ([entry]) => {
        if (!entry.isIntersecting) return;

        await registerEvent({
          tipoEvento: 'ROTA',
          obsEvento: `ID da rota: [${routeID}]`,
        });
      },
      { threshold: 0.01, root: null }
    );
    observer.observe(el);

    return () => observer.disconnect();
  }, [routeID, location.key]);

  return (
    <View ref={viewRef}>
      {children}
    </View>
  );
}